import { isMac } from "@root/utils";
import { replace, pipe, when } from "ramda";
export var humanizeKeySequence = function humanizeKeySequence(keySequence) {
    return pipe(when(function () {
        return isMac;
    }, replace("command", "⌘")), when(function () {
        return isMac;
    }, replace("opt", "⌥")))(keySequence);
};
